export {};
//# sourceMappingURL=IPageViewTelemetry.js.map